import { render, staticRenderFns } from "./rgTemplateTable.vue?vue&type=template&id=942fa07e&scoped=true&"
import script from "./rgTemplateTable.vue?vue&type=script&lang=ts&"
export * from "./rgTemplateTable.vue?vue&type=script&lang=ts&"
import style0 from "./rgTemplateTable.vue?vue&type=style&index=0&id=942fa07e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942fa07e",
  null
  
)

export default component.exports